import type { GqlRemoteExtensionsConfiguration } from 'types/graphql';

const LIVE_PREVIEW_SCOPE = 'customer_themes';

/** Reads `manifest_url` and `theme` query params to build a live preview config for module federation. */
export function getLivePreviewConfig(): GqlRemoteExtensionsConfiguration | null {
  if (typeof window === 'undefined') return null;

  const params = new URLSearchParams(window.location.search);
  const manifestUrl = params.get('manifest_url');
  const theme = params.get('theme');

  if (!manifestUrl || !theme) return null;

  // Only allow localhost origins for live preview to prevent abuse
  try {
    const url = new URL(manifestUrl);
    if (!['localhost', '127.0.0.1'].includes(url.hostname)) return null;
  } catch {
    return null;
  }

  return {
    manifestUrl,
    modulePath: `themes/${theme}`,
    scope: LIVE_PREVIEW_SCOPE,
  };
}
